import { Map as ImmutableMap } from 'immutable'
import { useMemo } from 'react'
import type { NinetailedFeatureFlagSchema } from './useNinetailedFeatureFlag/schema'
import { useNinetailedFeatureFlagsQuery } from './useNinetailedFeatureFlagsQuery'

export const useNinetailedFeatureFlagAtomisedData = () => {
  const ninetailedFeatureFlagData = useNinetailedFeatureFlagsQuery()
  const ninetailedFeatureFlagAtomisedData: ImmutableMap<
    string,
    NinetailedFeatureFlagSchema
  > = useMemo(() => {
    return ninetailedFeatureFlagData.ntFeatureFlagCollection.items.reduce(
      (acc, ntFeatureFlagEntry) =>
        acc.set(ntFeatureFlagEntry.sys.id, ntFeatureFlagEntry),
      ImmutableMap<string, NinetailedFeatureFlagSchema>()
    )
  }, [ninetailedFeatureFlagData])
  return ninetailedFeatureFlagAtomisedData
}
